import {LOCAL_STORAGE_TOKEN} from "../constants";

export function setLocalAuth(authToken: string) {
  localStorage.setItem(LOCAL_STORAGE_TOKEN, authToken)
}

export function getLocalAuth() {
  return localStorage.getItem(LOCAL_STORAGE_TOKEN);
}
